var header = document.querySelector('header.wp-block-template-part');
var body = document.body;
var lastScrollTop = 0;
var scrollThreshold = 0; // Minimum scroll distance to trigger header state change
var scrollTimeout = null; // For debouncing

function updateHeaderState() {
	if (!header) return;

	var scrollTop = window.scrollY;
	// If body is currently locked (menu/search), don't change header classes
	if (window.isBodyLocked === true) {
		lastScrollTop = scrollTop;
		return;
	}
	var windowHeight = window.innerHeight;
	var documentHeight = document.documentElement.scrollHeight;

	// 5px tolerance to account for floating-point issues
	var isAtBottom = scrollTop + windowHeight >= documentHeight - 5;

	var isMegaHover = window.isMegaHover === true;
	var isSearchActive = window.isSearchActive === true;

	// Do not toggle body classes here to avoid header flips while locked

	// Skip toggling when user is at bottom of page
	if (isAtBottom) {
		lastScrollTop = scrollTop;
		return;
	}

	// If mega menu or search is active, force header visible
	if (isMegaHover || isSearchActive) {
		header.classList.add(
			'header-fixed',
			'headroom--not-top',
			'headroom--pinned'
		);
		header.classList.remove(
			'headroom--top',
			'headroom--unpinned',
			'has__unpined__animation'
		);
	} else {
		if (scrollTop === 0) {
			// At very top
			header.classList.remove(
				'headroom--not-top',
				'headroom--unpinned',
				'has__unpined__animation',
				'headroom--pinned',
				'header-fixed'
			);
			header.classList.add('headroom--top');
		} else if (scrollTop <= scrollThreshold) {
			// Near top
			header.classList.remove(
				'headroom--top',
				'headroom--unpinned',
				'has__unpined__animation',
				'header-fixed'
			);
			header.classList.add('headroom--not-top', 'headroom--pinned');
		} else if (
			scrollTop > lastScrollTop &&
			Math.abs(scrollTop - lastScrollTop) > scrollThreshold
		) {
			// Scrolling down
			header.classList.remove(
				'headroom--top',
				'headroom--pinned',
				'header-fixed'
			);
			header.classList.add(
				'headroom--not-top',
				'headroom--unpinned',
				'has__unpined__animation'
			);
		} else if (
			scrollTop < lastScrollTop &&
			Math.abs(scrollTop - lastScrollTop) > scrollThreshold
		) {
			// Scrolling up
			header.classList.remove(
				'headroom--top',
				'headroom--unpinned',
				'has__unpined__animation',
				'header-fixed'
			);
			header.classList.add('headroom--not-top', 'headroom--pinned');
		}
	}

	lastScrollTop = scrollTop;
}

function initializeHeaderState() {
	if (!header) return;

	var scrollTop = window.scrollY;

	if (scrollTop === 0) {
		header.classList.add('headroom--top');
		header.classList.remove(
			'headroom--not-top',
			'headroom--unpinned',
			'headroom--pinned',
			'has__unpined__animation',
			'header-fixed'
		);
	} else {
		header.classList.add('headroom--not-top', 'headroom--pinned');
		header.classList.remove(
			'headroom--top',
			'headroom--unpinned',
			'has__unpined__animation',
			'header-fixed'
		);
	}
}

// Debounced scroll handler
function onScroll() {
	if (scrollTimeout) clearTimeout(scrollTimeout);
	scrollTimeout = setTimeout(updateHeaderState, 10); // 10ms debounce
}

// Events
window.addEventListener('scroll', onScroll, { passive: true });
document.addEventListener('headerStateUpdate', updateHeaderState);
document.addEventListener('DOMContentLoaded', initializeHeaderState);
window.addEventListener('load', initializeHeaderState);

(function () {
	const header = document.querySelector('header.site-header');
	const menuItems = document.querySelectorAll(
		'.wp-block-matat-pandora-mega-menu-item-mega'
	);
	const searchInput = document.querySelector('.dgwt-wcas-search-input');

	function isSafari() {
		const userAgent = window.navigator.userAgent;
		return (
			/iP(ad|hone|od)/.test(userAgent) || // iOS Safari
			(/Safari/.test(userAgent) &&
				!/Chrome/.test(userAgent) &&
				!/Edge/.test(userAgent))
		); // macOS Safari
	}
	function getScrollbarWidth() {
		return window.innerWidth - document.documentElement.clientWidth;
	}

	let lastScroll = 0;
	let activeLocks = new Set();

	// Prevent scroll function for Safari
	function preventScroll(e) {
		e.preventDefault();
		e.stopPropagation();
		return false;
	}

	// Prevent keyboard scrolling (arrows, space, page up/down, home/end)
	function preventScrollKeys(e) {
		const keys = [
			'ArrowUp',
			'ArrowDown',
			'ArrowLeft',
			'ArrowRight',
			'PageUp',
			'PageDown',
			'Home',
			'End',
			'Space',
		];
		if (keys.includes(e.code) || keys.includes(e.key)) {
			e.preventDefault();
			e.stopPropagation();
			return false;
		}
	}

	// Keep scroll snapped to lastScroll
	function snapScroll() {
		if (window.scrollY !== lastScroll) {
			window.scrollTo(0, lastScroll);
		}
	}

	function applyLock() {
		lastScroll = window.scrollY;
		window.isBodyLocked = true;

		// Ensure header shows default state while locked
		try {
			var lockHeader =
				document.querySelector('header.wp-block-template-part') ||
				document.querySelector('header.site-header');
			if (lockHeader) {
				lockHeader.classList.add('default');
			}
		} catch (e) {}

		if (isSafari()) {
			// Safari: keep scrollbar visible on left (RTL) and lock scroll without hiding it
			document.documentElement.style.overflowY = 'scroll';
			document.documentElement.style.direction = 'rtl';
			document.body.style.overflow = 'hidden';
			// Prevent scroll interactions and snap back if necessary
			document.addEventListener('wheel', preventScroll, {
				passive: false,
			});
			document.addEventListener('touchmove', preventScroll, {
				passive: false,
			});
			document.addEventListener('keydown', preventScrollKeys, {
				passive: false,
			});
			window.addEventListener('scroll', snapScroll, { passive: true });
		} else {
			// Other browsers: hide scrollbar with padding compensation
			const scrollbarWidth = getScrollbarWidth();
			document.body.style.overflow = 'hidden';
			document.body.style.paddingRight =
				scrollbarWidth > 0 ? scrollbarWidth + 'px' : '0';
		}
	}

	function clearLock() {
		if (isSafari()) {
			// Restore scrollbar and remove listeners
			document.documentElement.style.overflowY = '';
			document.documentElement.style.direction = '';
			document.body.style.overflow = '';
			document.removeEventListener('wheel', preventScroll);
			document.removeEventListener('touchmove', preventScroll);
			document.removeEventListener('keydown', preventScrollKeys);
			window.removeEventListener('scroll', snapScroll);
			window.scrollTo(0, lastScroll);
		} else {
			document.body.style.overflow = '';
			document.body.style.paddingRight = '';
		}

		// Remove default lock state on header when unlocked
		try {
			var lockHeader =
				document.querySelector('header.wp-block-template-part') ||
				document.querySelector('header.site-header');
			if (lockHeader) {
				lockHeader.classList.remove('default');
			}
		} catch (e) {}
		window.isBodyLocked = false;
	}

	function lock(source) {
		if (!activeLocks.has(source)) {
			activeLocks.add(source);
		}
		if (activeLocks.size === 1) {
			applyLock();
		}
		document.body.classList.add(`${source}-locked`);
	}

	function unlock(source) {
		if (activeLocks.has(source)) {
			activeLocks.delete(source);
			document.body.classList.remove(`${source}-locked`);
		}
		if (activeLocks.size === 0) {
			clearLock();
		}
	}

	// -------- MENU EVENTS -------- //
	menuItems.forEach((item) => {
		item.addEventListener('mouseenter', () => {
			if (isSafari()) {
				// Safari: do not lock body on menu hover
				item.classList.add('open');
			} else {
				lock('menu');
				item.classList.add('open');
			}
		});
		item.addEventListener('mouseleave', () => {
			if (isSafari()) {
				item.classList.remove('open');
			} else {
				unlock('menu');
				item.classList.remove('open');
			}
		});
	});

	// -------- SEARCH EVENTS -------- //
	if (searchInput) {
		searchInput.addEventListener('focus', () => {
			lock('search');
		});
		searchInput.addEventListener('blur', () => {
			unlock('search');
		});
	}
})();

document.addEventListener('DOMContentLoaded', () => {
	const header = document.querySelector('header.wp-block-template-part');
	if (!header) return;

	// Set default class on load
	header.classList.add('default');

	window.addEventListener('scroll', () => {
		if (window.scrollY > 0) {
			header.classList.remove('default');
			header.classList.add('scrolled');
		} else {
			header.classList.remove('scrolled');
			header.classList.add('default');
		}
	});
});
